import { render, staticRenderFns } from "./MarketViewLiveDetailV5American.vue?vue&type=template&id=725c1169&scoped=true"
import script from "./MarketViewLiveDetailV5American.vue?vue&type=script&lang=js"
export * from "./MarketViewLiveDetailV5American.vue?vue&type=script&lang=js"
import style0 from "./MarketViewLiveDetailV5American.vue?vue&type=style&index=0&id=725c1169&prod&scoped=true&lang=css"
import style1 from "./MarketViewLiveDetailV5American.vue?vue&type=style&index=1&id=725c1169&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725c1169",
  null
  
)

export default component.exports